import LegalPageLayout from "@/components/LegalPageLayout";
import SEO from "@/components/SEO";

export default function DataDeletion() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Data Deletion Instructions"
      updated="13 July 2026"
    >
      <SEO
        title="Data Deletion Instructions | Checkout DM"
        description="How merchants and customers can request deletion of personal data collected by Checkout DM, including Instagram account data."
        path="/data-deletion"
      />
      <p>
        This page explains how Merchants and Customers can request the
        deletion of personal data collected by <strong>CheckoutDM</strong>,
        operated by M/s Healthy Celeb, in connection with our use of the
        Meta Instagram Platform. This page also serves as our Data Deletion
        Instructions URL for Meta Platform compliance purposes.
      </p>

      <h2>1. If You Are a Merchant</h2>
      <p>
        If you connected your Instagram Business Account to CheckoutDM, you
        can request deletion of your account and associated data in either
        of the following ways:
      </p>
      <ul>
        <li>
          <strong>Disconnect within the app:</strong> Go to your Meta
          Instagram account's{" "}
          <a href="https://www.instagram.com/accounts/manage_access/" target="_blank" rel="noopener noreferrer">
            Apps and Websites settings
          </a>
          , find CheckoutDM, and remove access. This immediately revokes our
          access token for your account.
        </li>
        <li>
          <strong>Request full deletion by email:</strong> Send an email to{" "}
          <a href="mailto:support@checkoutdm.com">support@checkoutdm.com</a>{" "}
          with the subject line <strong>"Data Deletion Request"</strong>,
          including the Instagram handle or business name linked to your
          CheckoutDM account.
        </li>
      </ul>

      <h2>2. If You Are a Customer</h2>
      <p>
        If you messaged a Merchant's Instagram account that uses CheckoutDM,
        and provided details such as your name, phone number, email, or
        shipping address during checkout, you can request deletion by:
      </p>
      <ul>
        <li>Contacting the Merchant you transacted with directly, or</li>
        <li>
          Emailing{" "}
          <a href="mailto:support@checkoutdm.com">support@checkoutdm.com</a>{" "}
          with the subject line <strong>"Data Deletion Request"</strong>,
          along with your Instagram handle and/or order details (e.g.
          Merchant name, approximate order date) so we can locate your
          records.
        </li>
      </ul>

      <h2>3. What Happens Next</h2>
      <ul>
        <li>We will verify the request and identify the relevant data using the information you provide.</li>
        <li>
          Your data — including conversation details, contact information,
          and order records tied to your identifier — will be deleted from
          our systems within <strong>30 days</strong> of a verified request.
        </li>
        <li>We will send a confirmation email once deletion is complete.</li>
        <li>Some information may be retained beyond 30 days where required by law, such as transaction and tax records under Indian law, but such data will no longer be used for any other purpose.</li>
      </ul>

      <h2>4. What Gets Deleted</h2>
      <p>
        A deletion request removes the personal data associated with your
        Instagram-Scoped ID (IGSID) or Merchant account from our database,
        including stored name, phone number, email, address, order history,
        and conversation data. It does not affect messages stored within
        Instagram/Meta's own systems, which are governed by{" "}
        <a href="https://www.facebook.com/about/privacy" target="_blank" rel="noopener noreferrer">
          Meta's Data Policy
        </a>
        .
      </p>

      <h2>5. Contact Us</h2>
      <p>For any questions about this process or to submit a deletion request, contact us at:</p>
      <p>
        <a href="mailto:support@checkoutdm.com">support@checkoutdm.com</a>
        <br />
        #989, FF, Sector - 11, Panchkula, Haryana, India - 134112
      </p>

      <p>
        See also our <a href="/privacy-policy">Privacy Policy</a> and{" "}
        <a href="/terms-of-service">Terms of Service</a>.
      </p>
    </LegalPageLayout>
  );
}
